"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractDetailsStateKeys = exports.availableStateOptions = exports.countriesWithLimitedStateAvailability = exports.countryAddressDetails = exports.stateTypes = exports.brazilCountryCode = exports.philippinesCountryCode = exports.newZealandCountryCode = exports.argentinaCountryCode = exports.switzerlandCountryCode = exports.colombiaCountryCode = exports.australiaCountryCode = exports.southAfricaCountryCode = exports.mexicoCountryCode = exports.canadaCountryCode = exports.usCountryCode = exports.philippinesProvincesOptions = exports.switzerlandCantonsOptions = exports.newZealandStatesOptions = exports.colombiaStatesOptions = exports.mexicoStatesOptions = exports.southAfricaProvincesOptions = exports.brazilStatesOptions = exports.usStatesOptions = exports.australiaStatesOptions = exports.canadaProvincesOptions = exports.argentinaProvincesOptions = exports.colombiaStates = exports.mexicoStates = exports.southAfricaProvinces = exports.canadaProvinces = exports.usStates = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _countryAddressDetail, _availableStateOption, _contractDetailsState;

var usStates = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  UM: 'U.S. Minor Outlying Islands',
  VI: 'U.S. Virgin Islands'
};
exports.usStates = usStates;
var canadaProvinces = {
  AB: 'Alberta',
  BC: 'British Columbia',
  // MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  // NT: 'Northwest Territories',
  NS: 'Nova Scotia',
  // NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island' // QC: 'Quebec',
  // SK: 'Saskatchewan',
  // YT: 'Yukon',

};
exports.canadaProvinces = canadaProvinces;
var southAfricaProvinces = ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'Western Cape', 'North West'];
exports.southAfricaProvinces = southAfricaProvinces;
var mexicoStates = ['Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Mexico City', 'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'México', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'];
exports.mexicoStates = mexicoStates;
var brazilStates = {
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapá',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Pará',
  PB: 'Paraíba',
  PE: 'Pernambuco',
  PI: 'Piauí',
  PR: 'Paraná',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondônia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'São Paulo',
  TO: 'Tocantins'
}; // for now, contractors can be from any country.
// transferwise need these state values

var australiaStates = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia'
};

var buildStateOptionsWithCodes = function buildStateOptionsWithCodes(stateOptions) {
  return Object.entries(stateOptions).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        stateCode = _ref2[0],
        stateLabel = _ref2[1];

    return {
      value: stateCode,
      label: "".concat(stateLabel, " (").concat(stateCode, ")")
    };
  });
};

var buildOptionsFromList = function buildOptionsFromList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (value) {
    return {
      value: value,
      label: value
    };
  });
};

var colombiaStates = ['Capital District', 'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bolívar', 'Boyacá', 'Caldas', 'Caquetá', 'Casanare', 'Cauca', 'Cesar', 'Chocó', 'Córdoba', 'Cundinamarca', 'Guainía', 'Guaviare', 'Huila', 'La Guajira', 'Magdalena', 'Meta', 'Nariño', 'Norte de Santander', 'Putumayo', 'Quindío', 'Risaralda', 'San Andrés y Providencia', 'Santander', 'Sucre', 'Tolima', 'Valle del Cauca', 'Vaupés', 'Vichada'];
exports.colombiaStates = colombiaStates;
var switzerlandCantons = ['Zürich', 'Bern; Berne', 'Luzern', 'Uri', 'Schwyz', 'Obwalden', 'Nidwalden', 'Glarus', 'Zug', 'Fribourg; Freiburg', 'Solothurn', 'Basel-Stadt', 'Basel-Landschaft', 'Schaffhausen', 'Appenzell Ausserrhoden', 'Appenzell Innerrhoden', 'St. Gallen', 'Graubünden; Grischun; Grigioni', 'Aargau', 'Thurgau', 'Ticino', 'Vaud', 'Valais; Wallis', 'Neuchâtel', 'Genève', 'Jura'];
var argentinaProvinces = ['Capital Federal', 'Buenos Aires', 'Catamarca', 'Córdoba', 'Corrientes', 'Chaco', 'Chubut', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'];
var newZealandStates = ['Auckland', 'Bay Of Plenty', 'Canterbury', 'Gisborne', "Hawke's Bay", 'Wanganui - Manawatu', 'Marlborough', 'Nelson - Tasman', 'Northland', 'Otago', 'Southland', 'Taranaki', 'Waikato', 'Wellington', 'West Coast'];
var philippinesProvinces = ['Abra', 'Agusan del Norte', 'Agusan del Sur', 'Aklan', 'Albay', 'Antique', 'Apayao', 'Aurora', 'Basilan', 'Bataan', 'Batanes', 'Batangas', 'Benguet', 'Biliran', 'Bohol', 'Bukidnon', 'Bulacan', 'Cagayan', 'Camarines Norte	Daet', 'Camarines Sur', 'Camiguin', 'Capiz', 'Catanduanes	Virac', 'Cavite', 'Cebu', 'Cotabato', 'Mindanao', 'Davao del Norte', 'Davao del Sur', 'Davao Occidental', 'Davao Oriental', 'Dinagat Islands', 'Eastern Samar', 'Guimaras', 'Ifugao', 'Ilocos Norte', 'Ilocos Sur', 'Iloilo', 'Isabela', 'Kalinga', 'La Union', 'Laguna', 'Lanao del Norte', 'Lanao del Sur', 'Leyte', 'Maguindanao', 'Marinduque', 'Masbate', 'Metro Manila', 'Misamis Occidental', 'Misamis Oriental', 'Mountain Province', 'Negros Occidental', 'Negros Oriental', 'Northern Samar', 'Nueva Ecija', 'Nueva Vizcaya', 'Occidental Mindoro', 'Oriental Mindoro', 'Palawan', 'Pampanga', 'Pangasinan', 'Quezon', 'Quirino', 'Rizal', 'Romblon', 'Samar', 'Sarangani', 'Siquijor', 'Sorsogon', 'South Cotabato', 'Southern Leyte', 'Sultan Kudarat', 'Sulu', 'Surigao del Norte', 'Surigao del Sur', 'Tarlac', 'Tawi-Tawi', 'Zambales', 'Zamboanga del Norte', 'Zamboanga del Sur', 'Zamboanga Sibugay'];
var argentinaProvincesOptions = buildOptionsFromList(argentinaProvinces);
exports.argentinaProvincesOptions = argentinaProvincesOptions;
var canadaProvincesOptions = buildStateOptionsWithCodes(canadaProvinces);
exports.canadaProvincesOptions = canadaProvincesOptions;
var australiaStatesOptions = buildStateOptionsWithCodes(australiaStates);
exports.australiaStatesOptions = australiaStatesOptions;
var usStatesOptions = buildStateOptionsWithCodes(usStates);
exports.usStatesOptions = usStatesOptions;
var brazilStatesOptions = buildStateOptionsWithCodes(brazilStates);
exports.brazilStatesOptions = brazilStatesOptions;
var southAfricaProvincesOptions = buildOptionsFromList(southAfricaProvinces);
exports.southAfricaProvincesOptions = southAfricaProvincesOptions;
var mexicoStatesOptions = buildOptionsFromList(mexicoStates);
exports.mexicoStatesOptions = mexicoStatesOptions;
var colombiaStatesOptions = buildOptionsFromList(colombiaStates);
exports.colombiaStatesOptions = colombiaStatesOptions;
var newZealandStatesOptions = buildOptionsFromList(newZealandStates);
exports.newZealandStatesOptions = newZealandStatesOptions;
var switzerlandCantonsOptions = buildOptionsFromList(switzerlandCantons);
exports.switzerlandCantonsOptions = switzerlandCantonsOptions;
var philippinesProvincesOptions = philippinesProvinces.map(function (state) {
  return {
    value: state,
    label: state
  };
});
exports.philippinesProvincesOptions = philippinesProvincesOptions;
var usCountryCode = 'USA';
exports.usCountryCode = usCountryCode;
var canadaCountryCode = 'CAN';
exports.canadaCountryCode = canadaCountryCode;
var mexicoCountryCode = 'MEX';
exports.mexicoCountryCode = mexicoCountryCode;
var southAfricaCountryCode = 'ZAF';
exports.southAfricaCountryCode = southAfricaCountryCode;
var australiaCountryCode = 'AUS';
exports.australiaCountryCode = australiaCountryCode;
var colombiaCountryCode = 'COL';
exports.colombiaCountryCode = colombiaCountryCode;
var switzerlandCountryCode = 'CHE';
exports.switzerlandCountryCode = switzerlandCountryCode;
var argentinaCountryCode = 'ARG';
exports.argentinaCountryCode = argentinaCountryCode;
var newZealandCountryCode = 'NZL';
exports.newZealandCountryCode = newZealandCountryCode;
var philippinesCountryCode = 'PHL';
exports.philippinesCountryCode = philippinesCountryCode;
var brazilCountryCode = 'BRA';
exports.brazilCountryCode = brazilCountryCode;
var stateTypes = {
  PROVINCE: 'province',
  STATE: 'state',
  STATE_TERRITORY: 'state_territory',
  CANTON: 'canton'
};
exports.stateTypes = stateTypes;
var countryAddressDetails = (_countryAddressDetail = {}, (0, _defineProperty2["default"])(_countryAddressDetail, argentinaCountryCode, {
  states: {
    type: stateTypes.PROVINCE,
    options: argentinaProvincesOptions
  },
  localDetails: ['municipality']
}), (0, _defineProperty2["default"])(_countryAddressDetail, australiaCountryCode, {
  states: {
    type: stateTypes.STATE_TERRITORY,
    options: australiaStatesOptions
  },
  localDetails: ['suburb']
}), (0, _defineProperty2["default"])(_countryAddressDetail, brazilCountryCode, {
  states: {
    type: stateTypes.STATE,
    options: brazilStatesOptions
  },
  localDetails: ['district']
}), (0, _defineProperty2["default"])(_countryAddressDetail, canadaCountryCode, {
  states: {
    type: stateTypes.PROVINCE,
    options: canadaProvincesOptions
  }
}), (0, _defineProperty2["default"])(_countryAddressDetail, colombiaCountryCode, {
  states: {
    type: stateTypes.STATE,
    options: colombiaStatesOptions
  }
}), (0, _defineProperty2["default"])(_countryAddressDetail, mexicoCountryCode, {
  states: {
    type: stateTypes.STATE,
    options: mexicoStatesOptions
  }
}), (0, _defineProperty2["default"])(_countryAddressDetail, newZealandCountryCode, {
  states: {
    type: stateTypes.STATE,
    options: newZealandStatesOptions
  },
  localDetails: ['suburb']
}), (0, _defineProperty2["default"])(_countryAddressDetail, philippinesCountryCode, {
  states: {
    type: stateTypes.PROVINCE,
    options: philippinesProvincesOptions
  },
  localDetails: ['barangay']
}), (0, _defineProperty2["default"])(_countryAddressDetail, southAfricaCountryCode, {
  states: {
    type: stateTypes.PROVINCE,
    options: southAfricaProvincesOptions
  }
}), (0, _defineProperty2["default"])(_countryAddressDetail, switzerlandCountryCode, {
  states: {
    type: stateTypes.CANTON,
    options: switzerlandCantonsOptions
  }
}), (0, _defineProperty2["default"])(_countryAddressDetail, usCountryCode, {
  states: {
    type: stateTypes.STATE,
    options: usStatesOptions
  }
}), _countryAddressDetail); // EOR is not available for all states for some countries.

exports.countryAddressDetails = countryAddressDetails;
var countriesWithLimitedStateAvailability = [australiaCountryCode, canadaCountryCode, usCountryCode];
exports.countriesWithLimitedStateAvailability = countriesWithLimitedStateAvailability;
var availableAustralianStates = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  WA: 'Western Australia'
};
var availableCanadianProvinces = {
  AB: 'Alberta',
  BC: 'British Columbia',
  NB: 'New Brunswick',
  NS: 'Nova Scotia',
  ON: 'Ontario',
  QC: 'Quebec',
  SK: 'Saskatchewan'
};
var availableUSStates = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  IN: 'Indiana',
  ID: 'Idaho',
  IL: 'Illinois',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MO: 'Missouri',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MT: 'Montana',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  NC: 'North Carolina',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  DC: 'Washington DC',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};
var availableStateOptions = (_availableStateOption = {}, (0, _defineProperty2["default"])(_availableStateOption, australiaCountryCode, buildStateOptionsWithCodes(availableAustralianStates)), (0, _defineProperty2["default"])(_availableStateOption, canadaCountryCode, buildStateOptionsWithCodes(availableCanadianProvinces)), (0, _defineProperty2["default"])(_availableStateOption, usCountryCode, buildStateOptionsWithCodes(availableUSStates)), _availableStateOption);
exports.availableStateOptions = availableStateOptions;
var contractDetailsStateKeys = (_contractDetailsState = {}, (0, _defineProperty2["default"])(_contractDetailsState, australiaCountryCode, 'state'), (0, _defineProperty2["default"])(_contractDetailsState, canadaCountryCode, 'provinceOfResidency'), (0, _defineProperty2["default"])(_contractDetailsState, usCountryCode, 'stateOfResidency'), _contractDetailsState);
exports.contractDetailsStateKeys = contractDetailsStateKeys;